import { BehaviorSubject } from 'rxjs';
import { AuthApiService } from "./ApiService";
import CryptoJS from 'crypto-js';

const currentUserSubject = new BehaviorSubject();
const mfaUserSubject = new BehaviorSubject();
const pwdUserSubject = new BehaviorSubject();
const fpUserSubject = new BehaviorSubject();
const fpvUserSubject = new BehaviorSubject();

let userLoggedIn = false;
let mfaUserLoggedIn = false
let pwdUserLoggedIn = false;

export const authenticationService = {
    submitforgotPassVerfication,
    login,
    logout,
    isLoggedin,
    forgetPass,
    reauthenticate,
    submit2fa,
    changeNewPassword,
    resetPassword,
    currentSessionToken,
    checkIfTokenExpired,
    userLoggedIn,
    mfaUserLoggedIn,
    pwdUserLoggedIn,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value
    },
    currentfpUser: fpUserSubject.asObservable(),

    get currentfpUserValue() {
        return fpUserSubject.value
    },
    currentfpvUser: fpvUserSubject.asObservable(),

    get currentfpvUserValue() {
        return fpvUserSubject.value
    },

    currentMfaUser: mfaUserSubject.asObservable(),

    get currentMfaUserValue() {
        return mfaUserSubject.value
    },
    pwdUser: pwdUserSubject.asObservable(),

    get pwdUserValue() {
        return pwdUserSubject.value
    }
};

async function checkTokenRole(token) {
    const decryptedToken = (await CryptoJS.AES.decrypt(token, process.env.REACT_APP_AES_KEY)).toString(CryptoJS.enc.Utf8);

    const base64Url = decryptedToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);

}

async function checkIfTokenExpired(token) {
    const decryptedToken = (await CryptoJS.AES.decrypt(token, process.env.REACT_APP_AES_KEY)).toString(CryptoJS.enc.Utf8);

    const base64Url = decryptedToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    const payload = JSON.parse(jsonPayload);

    if (payload.exp) {
        const expirationTime = payload.exp * 1000; // Convert expiration time to milliseconds
        const currentTime = Date.now();

        if (currentTime >= expirationTime) {
            console.log('Token has expired');
            return true;
        } else {
            console.log('Token is still valid');
            return false;
        }
    } else {
        console.log('Token does not have expiration time');
        return false;
    }
}

async function login(email, password, recaptchaValue) {

    let response = await AuthApiService.signIn(email, password, recaptchaValue);
    if (response && response.status < 400) {
        let data = response.data
        let token = data.token
        let decodedToken = await checkTokenRole(token)
        if (decodedToken.role !== data.role) {
            data.role = decodedToken.role
            response.data.role = decodedToken.role
        }

        currentUserSubject.next(data);
        sessionStorage.setItem('loggedInUser', JSON.stringify(data))
        sessionStorage.setItem('userLoggedIn', String(true))

        if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === '2fa') {
            mfaUserLoggedIn = true;
            mfaUserSubject.next(data);
        } else if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'PASS') {
            if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === true) {
                pwdUserSubject.next(data)
                pwdUserLoggedIn = true
            } else {
                userLoggedIn = true;
                currentUserSubject.next(data);

            }
        }
    }

    return response;
}

async function submit2fa(mfaCode, email) {
    let response = await AuthApiService.submit2fa(mfaCode, email);
    if (response.status < 400) {
        let data = response.data
        currentUserSubject.next(data);
        sessionStorage.setItem('loggedInUser', JSON.stringify(data))
        sessionStorage.setItem('userLoggedIn', String(true))
        if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
            if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === true) {
                pwdUserSubject.next(data)
                pwdUserLoggedIn = true
            } else if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === false) {
                userLoggedIn = true;
                currentUserSubject.next(data);
            }
            mfaUserSubject.next(null);
            mfaUserLoggedIn = false
        }
    }

    return response;
}

async function submitforgotPassVerfication(mfaCode) {
    let response = await AuthApiService.submitForgotPasswordCode(mfaCode);
    if (response.status < 400) {
        let data = response.data
        currentUserSubject.next(data);
        sessionStorage.setItem('userLoggedIn', String(false))
    }

    return response;
}

async function forgetPass(email, recaptchaValue) {
    let response = await AuthApiService.forgetPass(email, recaptchaValue);

    if (response.status < 400) {
        let data = response.data
        await fpUserSubject.next(data);
        sessionStorage.setItem('fpUserLoggedIn', String(false))
        sessionStorage.setItem('userLoggedIn', String(false))
    }

    return response;
}


function reauthenticate() {
    let data = JSON.parse(sessionStorage.getItem('loggedInUser'))
    sessionStorage.setItem('userLoggedIn', String(true))
    currentUserSubject.next(data);
}

function isLoggedin() {
    return Boolean(sessionStorage.getItem('userLoggedIn') === "true" && sessionStorage.getItem('loggedInUser') !== "undefined")
}

async function changeNewPassword(password) {

    let response = await AuthApiService.changeNewPassword(password);
    if (response && response.status < 400) {
        let data = response.data
        if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
            userLoggedIn = true;
            currentUserSubject.next(data);
        }
    }

    return response;
}

async function currentSessionToken() {
    let user = JSON.parse(JSON.stringify(currentUserSubject['value']));
    let currentToken = user['token']
    let refreshToken = user['refreshToken']
    // let decodedToken = utils.parseJwt(currentToken)
    // let exp = (decodedToken['exp']) * 1000
    // let curTime = (new Date()).getTime()
    // let tokenExpired = curTime - exp > 0
    // return new Promise(async (resolve, reject) => {
    //     if (tokenExpired) {
    //         await refreshToken(refreshToken).then(async token => {
    //             //set new token to user
    //             user['token'] = token
    //             await currentUserSubject.next(user);
    //             sessionStorage.setItem('loggedInUser', JSON.stringify(user))
    //             resolve(token)
    //         }).catch(e => {
    //             console.error(e);
    //             reject(e);
    //         })
    //     } else {
    //         resolve(currentToken)
    //     }
    //
    // });
    return currentToken
}

async function resetPassword(email, reCaptchaToken) {
    return await AuthApiService.resetPassword(email, reCaptchaToken);
}

function logout() {
    console.log("logout")
    document.getElementById('root').click();
    userLoggedIn = false;
    currentUserSubject.next(null);
    sessionStorage.clear()
}
